const planificadorTareaEnumerators = {
  dirigidoA: ['Puesto', 'Ejecutor', 'Teams'],
  tipoTiempoLimite: ['days', 'months', 'years'],
  tipoPeriodicidad: ['days', 'weeks', 'months', 'years'],
  clasificacion: ['operativa', 'mantenimiento', 'incidente', 'investigacionIncidente'],
};

export default planificadorTareaEnumerators;
